<template>
    <div class="custom-input">
        <select v-if="isSelect"
            :id="name"
            :name="name"
            required
            autocomplete="off"
            v-emit
            ref="input"
            :type="type || 'text'"
            :inputmode="inputmode || 'select'"
            >
            <option :value="option.value" v-for="option in selectOptions" :key="option.value">
                {{ option.text }}
            </option>
        </select>
        <input v-else
            :type="type || 'text'"
            :id="name"
            :name="name"
            required
            autocomplete="off"
            v-emit
            ref="input"
            :inputmode="inputmode || 'text'"
        />
        <label :for="name">{{ label }}</label>
        <div class="bar"></div>
        <span v-if="error" class="error">{{ error }}</span>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        error: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: false
        },
        inputmode: {
            type: String,
            required: false,
        },
        isSelect: {
            type: Boolean,
            default: false 
        },
        selectOptions: {
            type: Array,
            required: false
        }

    },

    directives: {
        emit: {
            inserted (el, binding, { context }) {
                el.addEventListener('blur', () => {
                    context.$emit('blur', el.name);
                    context.$emit('validate', el);
                });
                el.addEventListener('input', () => {
                    context.$emit('input', el.value);
                    context.$emit('validate', { name: el.name, value: el.value, fromInputEvent: true });
                });
            }
        }
    }
};
</script>
